/**
 * 产品页服务保障 block — 信任项 Tip 气泡交互。
 *
 * PC（hover 设备）：CSS hover / focus-within 展示，无需点击。
 * 移动端：点击切换，点击外部或 Esc 关闭。
 *
 * 由 sections/main-product.liquid 按需加载。
 */
(function () {
  "use strict";

  if (window.ProductTrust) return;

  function isHoverCapable() {
    return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  }

  function closeAll(except) {
    document.querySelectorAll(".product-block-trust__tip-wrap.is-open").forEach(function (wrap) {
      if (wrap === except) return;

      wrap.classList.remove("is-open");

      var trigger = wrap.querySelector("[data-trust-tip-trigger]");

      if (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      }
    });
  }

  document.addEventListener("click", function (event) {
    if (isHoverCapable()) return;

    var trigger = event.target.closest("[data-trust-tip-trigger]");

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();

      var wrap = trigger.closest(".product-block-trust__tip-wrap");
      var isOpen = wrap.classList.contains("is-open");

      closeAll();

      if (!isOpen) {
        wrap.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      }

      return;
    }

    if (!event.target.closest(".product-block-trust__tip-wrap")) {
      closeAll();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (isHoverCapable()) return;

    if (event.key === "Escape") {
      closeAll();
    }
  });

  window.ProductTrust = true;
})();
